import { render, staticRenderFns } from "./InfoReminder.vue?vue&type=template&id=5cb33d82&scoped=true&"
import script from "./InfoReminder.vue?vue&type=script&lang=js&"
export * from "./InfoReminder.vue?vue&type=script&lang=js&"
import style0 from "./InfoReminder.vue?vue&type=style&index=0&id=5cb33d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb33d82",
  null
  
)

export default component.exports